


// import { useState, useEffect } from 'react';
// import React from 'react';
// import './FeaturedProducts.css';
// import ComponentsHub from '../ComponentsHub/ComponentsHub';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig'; // Adjust path as needed

// export default function FeaturedProducts({ currentCategory }) {
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [firestoreProducts, setFirestoreProducts] = useState({});
//   const [categories, setCategories] = useState([]);
  
//   // Define category groups with special handling
//   const customProductCategories = ['3d-printing', 'fast-prototyping', 'iot-components'];
//   const comingSoonCategories = ['custom-battery', 'laser-cutting', 'pcb-manufacturing'];
  
//   useEffect(() => {
//     const fetchProductsAndCategories = async () => {
//       try {
//         setLoading(true);
        
//         const categoriesCollection = collection(db, 'designCategories');
//         const categoriesSnapshot = await getDocs(categoriesCollection);
        
//         const categoriesList = categoriesSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
        
//         setCategories(categoriesList);
        
//         const productsCollection = collection(db, 'featuredProducts');
//         const productsSnapshot = await getDocs(productsCollection);
        
//         const productsList = productsSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           name: doc.data().name || '',
//           image: doc.data().image || '',
//           price: doc.data().price || 0,
//           sku: doc.data().sku || '',
//           category: doc.data().category || '',
//         }));
        
//         const organizedProducts = {};
        
//         categoriesList.forEach(category => {
//           organizedProducts[category.slug || category.id] = [];
//         });
        
//         productsList.forEach(product => {
//           const category = categoriesList.find(cat => cat.id === product.category);
//           if (category) {
//             const categoryKey = category.slug || category.id;
//             if (!organizedProducts[categoryKey]) {
//               organizedProducts[categoryKey] = [];
//             }
//             organizedProducts[categoryKey].push(product);
//           }
//         });
        
//         setFirestoreProducts(organizedProducts);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching data from Firestore:", error);
//         setLoading(false);
//       }
//     };
    
//     fetchProductsAndCategories();
//   }, []);

//   const displayProducts = currentCategory
//     ? firestoreProducts[currentCategory] || []
//     : Object.values(firestoreProducts).flat();

//   useEffect(() => {
//     loadCartItems();
//     window.addEventListener('cartUpdated', loadCartItems);
//     return () => window.removeEventListener('cartUpdated', loadCartItems);
//   }, []);

//   const loadCartItems = () => {
//     try {
//       const existingCart = localStorage.getItem('cartItems');
//       if (existingCart) {
//         const parsedCart = JSON.parse(existingCart);
//         setCartItems(Array.isArray(parsedCart) ? parsedCart : []);
//       } else {
//         setCartItems([]);
//       }
//     } catch (error) {
//       console.error("Error loading cart items:", error);
//       setCartItems([]);
//     }
//   };

//   const isProductInCart = (productId) => cartItems.some(item => item.id === productId);
//   const getProductQuantity = (productId) => (cartItems.find(item => item.id === productId)?.quantity || 0);

//   const dispatchCartUpdate = () => {
//     window.dispatchEvent(new Event('cartUpdated'));
//   };

//   const handleAddToCart = (productId) => {
//     const product = Object.values(firestoreProducts).flat().find(p => p.id === productId);
//     if (!product) return;

//     try {
//       const existingCart = localStorage.getItem('cartItems') || '[]';
//       let cartArray = JSON.parse(existingCart);

//       const existingProductIndex = cartArray.findIndex(item => item.id === productId);
//       if (existingProductIndex >= 0) {
//         cartArray[existingProductIndex].quantity = (cartArray[existingProductIndex].quantity || 0) + 1;
//       } else {
//         cartArray.push({
//           id: product.id,
//           name: product.name,
//           price: product.price || 0,
//           quantity: 1,
//           imageUrl: product.image,
//           image: product.image,
//           deliverySpeed: product.deliverySpeed || 'normal',
//           originalDeliverySpeed: product.deliverySpeed || 'normal'
//         });
//       }

//       localStorage.setItem('cartItems', JSON.stringify(cartArray));
//       setCartItems(cartArray);
//       dispatchCartUpdate();
//       showAddToCartNotification(product.name);
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     }
//   };

//   const showAddToCartNotification = (productName) => {
//     const notification = document.createElement('div');
//     notification.className = 'cart-notification';
//     notification.textContent = `Added ${productName} to cart`;
//     document.body.appendChild(notification);
//     setTimeout(() => {
//       notification.classList.add('fade-out');
//       setTimeout(() => document.body.removeChild(notification), 500);
//     }, 2000);
//   };

//   const handleViewDetails = (productId) => {
//     const product = Object.values(firestoreProducts).flat().find(p => p.id === productId);
//     if (product) setSelectedProduct(product);
//   };

//   const handleCloseDetails = () => setSelectedProduct(null);
  
//   // Handle WhatsApp contact - opens in new tab
//   const handleWhatsAppContact = () => {
//     // Format: phone number without '+' or spaces, and URL-encoded message
//     const phoneNumber = "8861938913";
//     const message = encodeURIComponent("Hello! I'm interested in your customized products from your Design Makers Hub. Could you please provide more information?");
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
//     // Open in new tab
//     window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
//   };

//   if (selectedProduct) return <ComponentsHub product={selectedProduct} onClose={handleCloseDetails} />;
//   if (loading) return (
//     <div className="featured-products-section1">
//       <h2 className="featured-heading1">Featured Products</h2>
//       <div className="underline1"></div>
//       <div className="products-loading">
//         <div className="loading-spinner"></div>
//         <p>Loading products...</p>
//       </div>
//     </div>
//   );

//   // Render custom product message for specified categories
//   if (currentCategory && customProductCategories.includes(currentCategory)) {
//     // Get current category name for display
//     const categoryName = categories.find(cat => (cat.slug || cat.id) === currentCategory)?.name || 'this category';
    
//     return (
//       <div className="featured-products-section1">
//         <h2 className="featured-heading1">Customized Products</h2>
//         <div className="underline1"></div>
//         <div className="custom-products-message">
//           <div className="custom-products-icon">🛠️</div>
//           <h3>Customized Products Available</h3>
//           <p>We offer specialized and customized products in {categoryName}.</p>
//           <p>To purchase or get more details about these products, please contact our team directly:</p>
//           <div className="contact-number">
//             <i className="phone-icon">📱</i>  8861938913
//           </div>
//           <button className="whatsapp-contact-btn" onClick={handleWhatsAppContact}>
//             <span className="whatsapp-icon">💬</span> Contact via WhatsApp
//           </button>
//         </div>
//       </div>
//     );
//   }
  
//   // Render coming soon message for specified categories
//   if (currentCategory && comingSoonCategories.includes(currentCategory)) {
//     // Get current category name for display
//     const categoryName = categories.find(cat => (cat.slug || cat.id) === currentCategory)?.name || 'this category';
    
//     return (
//       <div className="featured-products-section1">
//         <h2 className="featured-heading1">Coming Soon</h2>
//         <div className="underline1"></div>
//         <div className="coming-soon-container">
//           <div className="coming-soon-icon">🚀</div>
//           <h3 className="coming-soon-title">Exciting Products Coming Soon!</h3>
//           <div className="coming-soon-message">
//             <p>We're working on bringing amazing {categoryName} products to you.</p>
//             <p>Stay tuned for innovative solutions that will transform your projects!</p>
//           </div>
//           <div className="countdown-animation">
//             <span className="dot"></span>
//             <span className="dot"></span>
//             <span className="dot"></span>
//           </div>
//           <p className="notify-text">Want to be notified when we launch?</p>
//           <button className="notify-btn" onClick={handleWhatsAppContact}>
//             <span className="bell-icon">🔔</span> Notify Me
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // Default product display for other categories
//   return (
//     <div className="featured-products-section1">
//       <h2 className="featured-heading1">Featured Products</h2>
//       <div className="underline1"></div>
//       {displayProducts.length > 0 ? (
//         <div className="products-grid1">
//           {displayProducts.map(product => (
//             <div key={product.id} className="product-card1">
//               <div className="product-category1">
//                 {categories.find(cat => cat.id === product.category)?.name || 'Uncategorized'}
//               </div>
//               <div className="product-image-container1">
//                 <img src={product.image} alt={product.name} className="product-image1" />
//               </div>
//               <h3 className="product-name1">{product.name}</h3>
//               <div className="product-sku1">SKU: {product.sku}</div>
//               <div className="product-price1">
//                 <span className="rupee-symbol1">₹</span> {product.price.toFixed(2)}
//                 <span className="gst-text1">(Incl. GST)</span>
//               </div>
//               <div className="product-actions1">
//                 <button className="view-details-btn1" onClick={() => handleViewDetails(product.id)}>View Details</button>
//                 <button className={`add-to-cart-btn1 ${isProductInCart(product.id) ? 'in-cart1' : ''}`} onClick={() => handleAddToCart(product.id)}>
//                   {isProductInCart(product.id) ? <span className="cart-quantity1">{getProductQuantity(product.id)}</span> : <span className="cart-icon1">🛒</span>}
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="no-products-message">
//           <p>No featured products available in this category.</p>
//         </div>
//       )}
//     </div>
//   );
// }



import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './FeaturedProducts.css';
import ComponentsHub from '../ComponentsHub/ComponentsHub';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig'; // Adjust path as needed

export default function FeaturedProducts({ currentCategory }) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firestoreProducts, setFirestoreProducts] = useState({});
  const [categories, setCategories] = useState([]);
  
  // Create a ref for the container element to scroll to
  const containerRef = useRef(null);
  
  // Define category groups with special handling
  const customProductCategories = ['3d-printing', 'fast-prototyping', 'iot-components'];
  const comingSoonCategories = ['custom-battery', 'laser-cutting', 'pcb-manufacturing'];
  
  // Auto-scroll to content section when category changes
  useEffect(() => {
    // Check if category is selected and container ref exists
    if (currentCategory && containerRef.current) {
      // Get the position of the container
      const containerPosition = containerRef.current.getBoundingClientRect();
      
      // Calculate scroll position - position from top minus some offset (e.g., 100px for header)
      const scrollOffset = 100; // Adjust this value based on your header height
      const scrollToPosition = window.pageYOffset + containerPosition.top - scrollOffset;
      
      // Scroll smoothly to the container
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [currentCategory]); // Run whenever currentCategory changes
  
  useEffect(() => {
    const fetchProductsAndCategories = async () => {
      try {
        setLoading(true);
        
        const categoriesCollection = collection(db, 'designCategories');
        const categoriesSnapshot = await getDocs(categoriesCollection);
        
        const categoriesList = categoriesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setCategories(categoriesList);
        
        const productsCollection = collection(db, 'featuredProducts');
        const productsSnapshot = await getDocs(productsCollection);
        
        const productsList = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          name: doc.data().name || '',
          image: doc.data().image || '',
          price: doc.data().price || 0,
          sku: doc.data().sku || '',
          category: doc.data().category || '',
        }));
        
        const organizedProducts = {};
        
        categoriesList.forEach(category => {
          organizedProducts[category.slug || category.id] = [];
        });
        
        productsList.forEach(product => {
          const category = categoriesList.find(cat => cat.id === product.category);
          if (category) {
            const categoryKey = category.slug || category.id;
            if (!organizedProducts[categoryKey]) {
              organizedProducts[categoryKey] = [];
            }
            organizedProducts[categoryKey].push(product);
          }
        });
        
        setFirestoreProducts(organizedProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
        setLoading(false);
      }
    };
    
    fetchProductsAndCategories();
  }, []);

  const displayProducts = currentCategory
    ? firestoreProducts[currentCategory] || []
    : Object.values(firestoreProducts).flat();

  useEffect(() => {
    loadCartItems();
    window.addEventListener('cartUpdated', loadCartItems);
    return () => window.removeEventListener('cartUpdated', loadCartItems);
  }, []);

  const loadCartItems = () => {
    try {
      const existingCart = localStorage.getItem('cartItems');
      if (existingCart) {
        const parsedCart = JSON.parse(existingCart);
        setCartItems(Array.isArray(parsedCart) ? parsedCart : []);
      } else {
        setCartItems([]);
      }
    } catch (error) {
      console.error("Error loading cart items:", error);
      setCartItems([]);
    }
  };

  const isProductInCart = (productId) => cartItems.some(item => item.id === productId);
  const getProductQuantity = (productId) => (cartItems.find(item => item.id === productId)?.quantity || 0);

  const dispatchCartUpdate = () => {
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const handleAddToCart = (productId) => {
    const product = Object.values(firestoreProducts).flat().find(p => p.id === productId);
    if (!product) return;

    try {
      const existingCart = localStorage.getItem('cartItems') || '[]';
      let cartArray = JSON.parse(existingCart);

      const existingProductIndex = cartArray.findIndex(item => item.id === productId);
      if (existingProductIndex >= 0) {
        cartArray[existingProductIndex].quantity = (cartArray[existingProductIndex].quantity || 0) + 1;
      } else {
        cartArray.push({
          id: product.id,
          name: product.name,
          price: product.price || 0,
          quantity: 1,
          imageUrl: product.image,
          image: product.image,
          deliverySpeed: product.deliverySpeed || 'normal',
          originalDeliverySpeed: product.deliverySpeed || 'normal'
        });
      }

      localStorage.setItem('cartItems', JSON.stringify(cartArray));
      setCartItems(cartArray);
      dispatchCartUpdate();
      showAddToCartNotification(product.name);
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const showAddToCartNotification = (productName) => {
    const notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.textContent = `Added ${productName} to cart`;
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.classList.add('fade-out');
      setTimeout(() => document.body.removeChild(notification), 500);
    }, 2000);
  };

  const handleViewDetails = (productId) => {
    const product = Object.values(firestoreProducts).flat().find(p => p.id === productId);
    if (product) setSelectedProduct(product);
  };

  const handleCloseDetails = () => setSelectedProduct(null);
  
  // Handle WhatsApp contact - opens in new tab
  const handleWhatsAppContact = () => {
    // Format: phone number without '+' or spaces, and URL-encoded message
    const phoneNumber = "8861938913";
    const message = encodeURIComponent("Hello! I'm interested in your customized products from your Design Makers Hub. Could you please provide more information?");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    // Open in new tab
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (selectedProduct) return <ComponentsHub product={selectedProduct} onClose={handleCloseDetails} />;
  if (loading) return (
    <div className="featured-products-section1" ref={containerRef}>
      <h2 className="featured-heading1">Featured Products</h2>
      <div className="underline1"></div>
      <div className="products-loading">
        <div className="loading-spinner"></div>
        <p>Loading products...</p>
      </div>
    </div>
  );

  // Render custom product message for specified categories
  if (currentCategory && customProductCategories.includes(currentCategory)) {
    // Get current category name for display
    const categoryName = categories.find(cat => (cat.slug || cat.id) === currentCategory)?.name || 'this category';
    
    return (
      <div className="featured-products-section1" ref={containerRef}>
        <h2 className="featured-heading1">Customized Products</h2>
        <div className="underline1"></div>
        <div className="custom-products-message">
          <div className="custom-products-icon">🛠️</div>
          <h3>Customized Products Available</h3>
          <p>We offer specialized and customized products in {categoryName}.</p>
          <p>To purchase or get more details about these products, please contact our team directly:</p>
          <div className="contact-number">
            <i className="phone-icon">📱</i>  8861938913
          </div>
          <button className="whatsapp-contact-btn" onClick={handleWhatsAppContact}>
            <span className="whatsapp-icon">💬</span> Contact via WhatsApp
          </button>
        </div>
      </div>
    );
  }
  
  // Render coming soon message for specified categories
  if (currentCategory && comingSoonCategories.includes(currentCategory)) {
    // Get current category name for display
    const categoryName = categories.find(cat => (cat.slug || cat.id) === currentCategory)?.name || 'this category';
    
    return (
      <div className="featured-products-section1" ref={containerRef}>
        <h2 className="featured-heading1">Coming Soon</h2>
        <div className="underline1"></div>
        <div className="coming-soon-container">
          <div className="coming-soon-icon">🚀</div>
          <h3 className="coming-soon-title">Exciting Products Coming Soon!</h3>
          <div className="coming-soon-message">
            <p>We're working on bringing amazing {categoryName} products to you.</p>
            <p>Stay tuned for innovative solutions that will transform your projects!</p>
          </div>
          <div className="countdown-animation">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <p className="notify-text">Want to be notified when we launch?</p>
          <button className="notify-btn" onClick={handleWhatsAppContact}>
            <span className="bell-icon">🔔</span> Notify Me
          </button>
        </div>
      </div>
    );
  }

  // Default product display for other categories
  return (
    <div className="featured-products-section1" ref={containerRef}>
      <h2 className="featured-heading1">Featured Products</h2>
      <div className="underline1"></div>
      {displayProducts.length > 0 ? (
        <div className="products-grid1">
          {displayProducts.map(product => (
            <div key={product.id} className="product-card1">
              <div className="product-category1">
                {categories.find(cat => cat.id === product.category)?.name || 'Uncategorized'}
              </div>
              <div className="product-image-container1">
                <img src={product.image} alt={product.name} className="product-image1" />
              </div>
              <h3 className="product-name1">{product.name}</h3>
              <div className="product-sku1">SKU: {product.sku}</div>
              <div className="product-price1">
                <span className="rupee-symbol1">₹</span> {product.price.toFixed(2)}
                <span className="gst-text1">(Incl. GST)</span>
              </div>
              <div className="product-actions1">
                <button className="view-details-btn1" onClick={() => handleViewDetails(product.id)}>View Details</button>
                <button className={`add-to-cart-btn1 ${isProductInCart(product.id) ? 'in-cart1' : ''}`} onClick={() => handleAddToCart(product.id)}>
                  {isProductInCart(product.id) ? <span className="cart-quantity1">{getProductQuantity(product.id)}</span> : <span className="cart-icon1">🛒</span>}
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-products-message">
          <p>No featured products available in this category.</p>
        </div>
      )}
    </div>
  );
}